// En prod (Docker), REACT_APP_API_URL="" => appels relatifs proxifies par nginx vers le backend.
// En dev, variable non definie => fallback localhost:8080.
const envUrl = process.env.REACT_APP_API_URL;
const API_URL = envUrl !== undefined ? envUrl : 'http://localhost:8080';
export default API_URL;
